import { useFlippers } from "../useFlippers/useFlippers";
import { useUnauthUrlFields } from "../useUnauthUrlFields/useUnauthUrlFields";

const RUPA_REDIRECT_UTM = {
  utm_source: "acquired-partners",
  utm_medium: "rupa",
  utm_campaign: "rupa-redirect",
} as const;

const useIsRupaRedirectExperience = (): boolean => {
  const [isRupaRedirectEnabled] = useFlippers("sonic_rupa_signup_redirect");
  const urlFields = useUnauthUrlFields();

  return (
    isRupaRedirectEnabled &&
    urlFields.utm_source === RUPA_REDIRECT_UTM.utm_source &&
    urlFields.utm_medium === RUPA_REDIRECT_UTM.utm_medium &&
    urlFields.utm_campaign === RUPA_REDIRECT_UTM.utm_campaign
  );
};

export { useIsRupaRedirectExperience, RUPA_REDIRECT_UTM };
